import React, { useState, useEffect, RefObject, useRef } from 'react';

import { useParams } from 'react-router-dom';

import { Formik, Form  } from 'formik';
// import './App.css';
import './styles.css';
import './styles-custom.css';

// import AdSense from './adSense/adSense';

import {
  Matiere,
  Simulation,
  simulationVide,
  Rubrique,
  EtapeSaisie,
  tabNotesOptions,
} from './types/main';
import {
} from './types/main';
import { EcranChargement } from './composantsSaisieAffichage/autres/ecranChargement';
import { FormConteneur } from './composantsSaisieAffichage/formConteneur';
// uniformiser provenance ?
import { COEF_OPTION1, COEF_OPTION2 } from './types/main';
import { SaisieTypeOption1 } from './composantsSaisieAffichage/fenetresSaisie/saisieTypeOption1';
import { SaisieFiliere } from './composantsSaisieAffichage/fenetresSaisie/saisieFiliere';
import { SaisieSpe } from './composantsSaisieAffichage/fenetresSaisie/saisieSpe';
import { SaisieNombreOptions } from './composantsSaisieAffichage/fenetresSaisie/saisieNombreOptions';
import { SaisieNoteCC } from './composantsSaisieAffichage/fenetresSaisie/saisieNoteCC';
import { Bilan } from './composantsSaisieAffichage/fenetresSaisie/bilan';
import { SaisieSousFiliereS } from './composantsSaisieAffichage/fenetresSaisie/saisieSousFiliereS';
import { getSimulationInLocalStorage, updateSimulationInLocalStorage } from './utils/localStorage';



export const EtapesBaseOptions = [
  {
    composant: <SaisieNombreOptions key="nbOptions" />,
    afficher: true,
  },
  {
    composant: <SaisieTypeOption1 key="natureOption1" />,
    afficher: true,
  },
] as EtapeSaisie[];


interface EtapesSaisieContextProps {
  nbEtapesSaisie: number;
  etapesSaisie: Rubrique[];
  setEtapesSaisie: (etapesSaisie: Rubrique[]) => void;
  indexRubriqueSaisie: number;
  indexEtapeDansRubrique: number;
  changeAffichage: (numRubrique: number, numEtape: number, affiche: boolean) => void;
  previousEtapeSaisie: () => void;
  nextEtapeSaisie: () => void;
  directToEtapeSaisie: (rubrique: number, etapeDansRubrique: number) => void;

  setEcranChargement: (afficher: boolean, message?: string) => void;

  popupAffiche: JSX.Element[];
  affichePopup: (element: JSX.Element, simu?: boolean) => void;
  closePopup: (all?: boolean) => void;
  popupCloseClass: string;
  refPopup: RefObject<HTMLDivElement>;

  simuLancee: boolean;
  setSimuLancee: (simuLancee: boolean) => void;
  changeEtapes: (etapes: EtapeSaisie[], numRubrique: number) => void;
  modifIndexes: boolean;
  setModifIndexes: (modifIndexes: boolean) => void;
  champInvalide: boolean;
  setChampInvalide: (champInvalide: boolean) => void;

  setSimulationLS: (simu: Simulation | null) => void;
}
export const EtapesSaisieContext = React.createContext({} as EtapesSaisieContextProps);
EtapesSaisieContext.displayName = 'EtapesSaisieContext';

interface Dimensions {
  borneTaille: number;
  largeur: number;
  hauteur: number;
  largeurInputs: number | string;
  largeurCol1: number | string;
  // largeurCol2: number | string;
  marginBodyHor: number | string;
  marginBodyVert: number | string;
}
const dimensionsVide = {
  borneTaille: 400,
  largeur: 0,
  hauteur: 0,
  largeurInputs: '100%',
  largeurCol1: '100%',
  // largeurCol2: '100%',
  marginBodyHor: 10,
  marginBodyVert: 10,
  Col1: null,
} as Dimensions;
interface ResponsiveContextProps {
  dimensions: Dimensions;
  setDimensions: (dimensions: Dimensions) => void;
  pageUnmount: string;
  isTactile: boolean;
}
export const ResponsiveContext = React.createContext({} as ResponsiveContextProps);
ResponsiveContext.displayName = 'ResponsiveContext';

interface KeyboardContextProps {
  shiftPressed: boolean;
  setShiftPressed: (shiftPressed: boolean) => void;
  ctrlPressed: boolean;
  setCtrlPressed: (shiftPressed: boolean) => void;
  enterDown: boolean;
  setEnterDown: (enterDown: boolean) => void;
  escapeDown: boolean;
  setEscapeDown: (escapeDown: boolean) => void;
}
export const KeyboardContext = React.createContext({} as KeyboardContextProps);
KeyboardContext.displayName = 'KeyboardContext';

interface Compteurs {
  rafraichRFR: number;
  rafraichTraitements: number;
}
interface DebugContextProps {
  getCompteurDebug: (nomCompteur: keyof Compteurs) => number;
  incrementeCompteurDebug: (nomCompteur: keyof Compteurs) => void;
}
export const DebugContext = React.createContext({} as DebugContextProps);
DebugContext.displayName = 'DebugContext';

const App: React.FC = () => {
  const [messageChargement, setMessageChargement] = useState('Chargement...');
  const [simulationLS, setSimulationLS] = useState<Simulation | null>(null);
  const [chargementEnCours, setChargementEnCours] = useState(false);
  const [isTactile, setIsTactile] = useState(false);
  const [dimensions, setDimensions] = useState(dimensionsVide);
  
  // pour la gestion des étapes de saisie
  const [indexRubriqueSaisie, setIndexRubriqueSaisie] = useState(0);
  const [indexEtapeDansRubrique, setIndexEtapeDansRubrique] = useState(0);
  const [modifIndexes, setModifIndexes] = useState(true);
  const [champInvalide, setChampInvalide] = useState(false);
  const [etapesSaisie, setEtapesSaisie] = useState<Rubrique[]>(
    [
      {
        // rubrique 0
        nomRubrique: 'Filière et Spécialité',
        vide: false,
        etapes: [
          {
            composant: <SaisieFiliere key="filiere" />,
            afficher: true,
          },
          {
            composant: <SaisieSousFiliereS key="sousFiliere" />,
            afficher: true,
          },
          {
            composant: <SaisieSpe key="specialite" />,
            afficher: true,
          },
        ],
      },
      {
        // rubrique 1
        nomRubrique: 'Epreuves anticipées',
        vide: false,
        etapes: [],
      },
      {
        // rubrique 2
        nomRubrique: 'Contrôle continu',
        vide: false,
        etapes: [],
      },
      {
        // rubrique 3
        nomRubrique: 'Options',
        vide: false,
        etapes: [
          ...EtapesBaseOptions,
          {
            composant: <SaisieNoteCC
              name="option_1"
              label="Option n°1"
              coef={COEF_OPTION1}
              pointsAuDessus10={true}
            />,
            afficher: true,
          },
          {
            composant: <SaisieNoteCC
              name="option_2"
              label="Option n°2"
              coef={COEF_OPTION2}
              pointsAuDessus10={true}
            />,
            afficher: true,
          }
        ],
      },
      {
        // rubrique 4
        nomRubrique: 'Bilan',
        vide: false,
        etapes: [
          {
            composant: <Bilan key="bilan" />,
            afficher: true,
          },
        ],
      },
    ]
  );
  const [nbEtapesSaisie, setNbEtapesSaisie] = useState(5);

  // pour popups
  const [popupCloseClass, addPopupCloseClass] = useState('');
  const [pageUnmount, setPageUnmount] = useState('disparait');
  const [popupAffiche, setPopupAffiche] = useState<JSX.Element[]>([]);
  const refPopup = useRef<HTMLDivElement>(null);

  // pour KeyboardContext
  const [shiftPressed, setShiftPressed] = useState(false);
  const [ctrlPressed, setCtrlPressed] = useState(false);
  const [enterDown, setEnterDown] = useState(false);
  const [escapeDown, setEscapeDown] = useState(false);
  const [simuLancee, setSimuLancee] = useState(false);
  const [compteursDebug, setCompteursDebug] = useState<Compteurs>({ rafraichRFR: 0, rafraichTraitements: 0 });

  const getCompteurDebug = (nomCompteur: keyof Compteurs): number => {
    return compteursDebug[nomCompteur];
  }
  const incrementeCompteurDebug = (nomCompteur: keyof Compteurs): void => {
    setCompteursDebug({ ...compteursDebug, [nomCompteur]: compteursDebug[nomCompteur] + 1 });
  }

  const setEcranChargement = (afficher: boolean, message?: string): void => {
    if (afficher) {
      setMessageChargement(message !== undefined ? message : 'Chargement...');
    }
    setChargementEnCours(afficher);
  }

  const isRubriqueVide = (rubrique: Rubrique): boolean => {
    let toutFalse = false;
    for (let i = 0; i < rubrique.etapes.length; i += 1) {
      toutFalse = toutFalse || rubrique.etapes[i].afficher;
    }
    return !toutFalse;
  }

  const directToEtapeSaisie = (rubrique: number, etapeDansRubrique: number): void => {
    setIndexesSaisie(rubrique, etapeDansRubrique);
  }

  const setIndexesSaisie = (rubrique: number, etapeDansRubrique: number): void => {
    // console.log('setIndexesSaisie', rubrique, etapeDansRubrique, etapesSaisie.length, etapesSaisie[rubrique].etapes.length, etapesSaisie[rubrique].etapes[etapeDansRubrique]);
    const sensLeave = rubrique > indexRubriqueSaisie ? 'left'
      : (rubrique === indexRubriqueSaisie && etapeDansRubrique > indexEtapeDansRubrique
        ? 'left' : 'right');
    const sensArrive = sensLeave === 'left' ? 'right' : 'left';
    // console.log('setIndexesSaisie', rubrique, etapeDansRubrique, etapesSaisie.length, etapesSaisie[rubrique].etapes.length);
    if (etapesSaisie.length > rubrique && etapesSaisie[rubrique].etapes.length > etapeDansRubrique
      && etapesSaisie[rubrique].etapes[etapeDansRubrique].afficher) {

      // console.log('setIndexesSaisie', rubrique, etapeDansRubrique);
      setTimeout(() => {
        setIndexEtapeDansRubrique(etapeDansRubrique);
        setIndexRubriqueSaisie(rubrique);
        setModifIndexes(true);
        setPageUnmount(`arrive-${sensArrive}`);
      }, 250);
    }
  }

  const changeAffichage = (numRubrique: number, numEtape: number, affiche: boolean): void => {
    if (etapesSaisie.length > numRubrique && etapesSaisie[numRubrique].etapes.length > numEtape) {
      const _etapesSaisie = [...etapesSaisie];
      const _etapes = [..._etapesSaisie[numRubrique].etapes];
      _etapes[numEtape].afficher = affiche;
      _etapesSaisie[numRubrique].etapes = _etapes;
      _etapesSaisie[numRubrique].vide = isRubriqueVide(_etapesSaisie[numRubrique]);
      setEtapesSaisie(_etapesSaisie);
      let a = etapesSaisie.length;
      for(let i = 0; i < etapesSaisie.length; i += 1) {
        if (isRubriqueVide(_etapesSaisie[numRubrique])) a -= 1;
      }
      setNbEtapesSaisie(a);
    }
  }

  const changeEtapes = (etapes: EtapeSaisie[], numRubrique: number): void => {
    const _etapesSaisie = [...etapesSaisie];
    const _etapeMatieres = { ..._etapesSaisie[numRubrique] };
    if (numRubrique === 3) {
      // console.log('numRubrique === 3', numRubrique);
      const etapesBase = [etapesSaisie[numRubrique].etapes[0], etapesSaisie[numRubrique].etapes[1]];
      _etapeMatieres.etapes = etapesBase.concat(etapes);
    } else {
      // console.log('numRubrique !== 3', numRubrique);
      _etapeMatieres.etapes = etapes;
    }
    _etapesSaisie[numRubrique] = _etapeMatieres;

    // console.log('changeEtapes', numRubrique);
    // console.log(etapesSaisie[numRubrique].etapes);
    // console.log(_etapesSaisie[numRubrique].etapes);

    setEtapesSaisie(_etapesSaisie);
  }

  const nextEtapeSaisie = (_indexRubriqueSaisie?: number, _indexEtapeDansRubrique?: number): void => {
    if (champInvalide) {
      alert('Vérifiez vos valeurs');
      return;
    }

    // console.log('nextEtapeSaisie indexRubriqueSaisie, indexEtapeDansRubrique', indexRubriqueSaisie, indexEtapeDansRubrique);

    const __indexRubriqueSaisie = _indexRubriqueSaisie !== undefined ? _indexRubriqueSaisie : indexRubriqueSaisie;
    const __indexEtapeDansRubrique = _indexEtapeDansRubrique !== undefined ? _indexEtapeDansRubrique : indexEtapeDansRubrique;

    // console.log('nextEtapeSaisie __indexRubriqueSaisie, __indexEtapeDansRubrique', __indexRubriqueSaisie, __indexEtapeDansRubrique);
    
    if (etapesSaisie[__indexRubriqueSaisie].etapes.length > __indexEtapeDansRubrique + 1) {
      if (etapesSaisie[__indexRubriqueSaisie].etapes[__indexEtapeDansRubrique + 1].afficher) {
        setIndexesSaisie(__indexRubriqueSaisie, __indexEtapeDansRubrique + 1);
        return;
      } else {
        // setIndexesSaisie(__indexRubriqueSaisie, __indexEtapeDansRubrique + 1, true);
        nextEtapeSaisie(__indexRubriqueSaisie, __indexEtapeDansRubrique + 1);
        return;
      }
    } else {
      if (etapesSaisie.length > __indexRubriqueSaisie + 1) {
        if (etapesSaisie[__indexRubriqueSaisie + 1].etapes[0].afficher) {
          setIndexesSaisie(__indexRubriqueSaisie + 1, 0);
          return;
        } else {
          // setIndexesSaisie(__indexRubriqueSaisie + 1, 0, true)
          nextEtapeSaisie(__indexRubriqueSaisie + 1, 0);
          return;
        }
      } else {
        setIndexesSaisie(etapesSaisie.length - 1, etapesSaisie[etapesSaisie.length - 1].etapes.length - 1);
      }
    }
    return; // de sécu
  }

  const previousEtapeSaisie = (_indexRubriqueSaisie?: number, _indexEtapeDansRubrique?: number): void => {
    const __indexRubriqueSaisie = _indexRubriqueSaisie !== undefined ? _indexRubriqueSaisie : indexRubriqueSaisie;
    const __indexEtapeDansRubrique = _indexEtapeDansRubrique !== undefined ? _indexEtapeDansRubrique : indexEtapeDansRubrique;

    if (__indexEtapeDansRubrique > 0) {
      if (etapesSaisie[__indexRubriqueSaisie].etapes[__indexEtapeDansRubrique - 1].afficher) {
        setIndexesSaisie(__indexRubriqueSaisie, __indexEtapeDansRubrique - 1);
        return;
      } else {
        previousEtapeSaisie(__indexRubriqueSaisie, __indexEtapeDansRubrique - 1);
        return;
      }
    } else {
      if (__indexRubriqueSaisie > 0) {
        const dernierIndex = etapesSaisie[__indexRubriqueSaisie - 1].etapes.length - 1;
        if (etapesSaisie[__indexRubriqueSaisie - 1].etapes[dernierIndex].afficher) {
          setIndexesSaisie(__indexRubriqueSaisie - 1, dernierIndex);
          return;
        } else {
          previousEtapeSaisie(__indexRubriqueSaisie - 1, dernierIndex);
          return;
        }
      } else {
        setIndexesSaisie(0, 0);
      }
    }
    return; // de sécu
  }

  const closePopup = (all?: boolean): void => {
    const _popupAffiche = [...popupAffiche];
    _popupAffiche.pop();
    addPopupCloseClass('disparait');
    setTimeout(() => {
      if (all) {
        setPopupAffiche([]);
      } else {
        setPopupAffiche(_popupAffiche);
      }
      addPopupCloseClass('');
    }, 380);
  }

  const _setPopupAffiche = (element: JSX.Element): void => {
    // setEcranChargement(true, '');
    const _popupAffiche = [...popupAffiche];
    _popupAffiche.push(element);
    setPopupAffiche(_popupAffiche);
    addPopupCloseClass('apparait');
  }

  const handleResize = (): void => { /* */
    const largeur = typeof window !== 'undefined' ? window.innerWidth : 0;
    const hauteur = typeof window !== 'undefined' ? window.innerHeight : 0;
    const borneTaille = 400;
    // const margeEntreColonnes = 20;
    // const tailleMinColonne = 260;
    const marginBodyHor = typeof window !== 'undefined' ?
      (largeur > borneTaille ? Math.round(borneTaille / 20) : Math.round(largeur / 20)) : 0;
    const marginBodyVert = typeof window !== 'undefined' ?
      (hauteur > borneTaille ? Math.round(borneTaille / 20) : Math.round(largeur / 20)) : 0;
    const tailleMaxCol = borneTaille - 2 * marginBodyHor;
    setDimensions({
      borneTaille,
      largeur: largeur,
      hauteur: hauteur,
      largeurInputs: '100%',
      largeurCol1: largeur > borneTaille ? tailleMaxCol : '100%',
      // largeurCol2: 0.8 * largeur > tailleMinColonne * 2 + margeEntreColonnes ?
      //   Math.max(tailleMaxCol, tailleMinColonne)
      //   : '100%',
      marginBodyHor: 10,
      marginBodyVert: 10,
      // marginBodyHor,
      // marginBodyVert,
    })
    // console.log(typeof window !== 'undefined' ? window.innerWidth : '');
  }
  const classNameBody = ['body'];
  if (dimensions.largeur < dimensions.borneTaille) {
    classNameBody.push('petiteLargeur');
  }

  useEffect(() => {
    // console.log('useEffect App etapesSaisie[1].etapes boucle ?');

    if (etapesSaisie[1].etapes.length !== 0) {
      // console.log('useEffect App etapesSaisie[1].etapes.length !== 0', etapesSaisie[1].etapes);
      nextEtapeSaisie();
    }
  }, [etapesSaisie[1].etapes.length]);

  useEffect(() => {
    // console.log('useEffect App etapesSaisie[2].etapes boucle ?');
    
    if (etapesSaisie[2].etapes.length !== 0) {
      // console.log('useEffect App etapesSaisie[2].etapes.length !== 0', etapesSaisie[2].etapes);
      nextEtapeSaisie();
    }
  }, [etapesSaisie[2].etapes.length]);

  useEffect(() => {
    setSimulationLS(getSimulationInLocalStorage(''));
    handleResize();
    const is_touch_device4 = (): boolean => {

      const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');

      const mq = (query: string): boolean => {
        return window.matchMedia(query).matches;
      }

      // old version commentée mais ropnchonnait car mélange ||et &&
      // if (('ontouchstart' in window) || window.Touch && document instanceof Touch) {
      if ('ontouchstart' in window || (window.Touch && document instanceof Touch)) {
        return true;
      }

      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
    }

    // alert(is_touch_device4() ? "Ceci est une interface tactile" : "Ceci n'est pas une interface tactile");
    setIsTactile(is_touch_device4());

    window.addEventListener('resize', handleResize);

    return (): void => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <EtapesSaisieContext.Provider value={{
      nbEtapesSaisie, etapesSaisie, setEtapesSaisie,
      indexRubriqueSaisie, indexEtapeDansRubrique,
      changeAffichage,
      previousEtapeSaisie, nextEtapeSaisie,
      directToEtapeSaisie,

      setEcranChargement,
      popupAffiche,
      affichePopup: _setPopupAffiche,
      popupCloseClass, closePopup, refPopup,
      simuLancee, setSimuLancee,
      changeEtapes, modifIndexes, setModifIndexes,
      champInvalide, setChampInvalide,

      setSimulationLS,
    }}>
      <ResponsiveContext.Provider value={{
        dimensions,
        setDimensions,
        pageUnmount,
        isTactile,
      }}>
        <KeyboardContext.Provider value={{
          shiftPressed, setShiftPressed,
          ctrlPressed, setCtrlPressed,
          enterDown, setEnterDown,
          escapeDown, setEscapeDown,
        }}>
          <DebugContext.Provider value={{
            getCompteurDebug,
            incrementeCompteurDebug,
          }}>
            <div
              className={dimensions.largeur < 400 ? 'moins400'
                : (dimensions.largeur < 600 ? 'moins600'
                  : (dimensions.largeur < 800 ? 'moins800' : ''))}
            >
              <div>
                {chargementEnCours && <EcranChargement message={messageChargement} />}
              </div>
              <Formik
                initialValues={simulationLS ? simulationLS : { ...simulationVide }}
                validate={(values): Simulation => {
                  const errors = { ...simulationVide } as Simulation;
                  // if (!values.beneficiaire.nom) {
                  //   errors.beneficiaire.nom = 'Requis';
                  // } else if (
                    // !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
                  //   values.beneficiaire.nom.length < 3
                  // ) {
                  //   errors.beneficiaire.nom = 'Si court ?';
                  // }
                  return errors;
                // }
                }}
                onSubmit={(values, { setSubmitting }): void => {
                  console.log('submit');
                  
                  setTimeout(() => {
                    alert(JSON.stringify(values, null, 2));
                    setSubmitting(false);
                  }, 400);
                }}
              >
                {(/*{ isSubmitting }*/): JSX.Element => (
                  <Form>
                    <div
                      className={classNameBody.join(' ')}
                      style={{
                        marginTop: dimensions.marginBodyVert,
                        marginBottom: dimensions.marginBodyVert,
                        marginRight: dimensions.marginBodyHor,
                        marginLeft: dimensions.marginBodyHor,
                      }}
                    >
                      <FormConteneur />
                      {/* <AdSense.Google client="ca-pub-7294685621972381" /> */}
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </DebugContext.Provider>
        </KeyboardContext.Provider>
      </ResponsiveContext.Provider>
    </EtapesSaisieContext.Provider>
  );
}

export default App;
